import { z } from 'zod';

/**
 * INDEX FILTERS CONFIGURATION
 */
export const IndexFilter_Config_S = z.object({
    name: z.string(),
    identifier: z.string(),
});

export const IndexFilters_Config_S = z.array(IndexFilter_Config_S);

/**
 * INDEX FILTERS STATE
 */
export const IndexFilter_State_S = IndexFilter_Config_S;

export const IndexFilters_State_S = z.array(IndexFilter_State_S);

/**
 * INDEX FILTERS CONTROLS STATE
 */
export const IndexFilter_ControlsState_S = IndexFilter_Config_S.pick({ identifier: true }).extend({
    isChecked: z.boolean(),
});

export const IndexFilters_ControlsState_S = z.array(IndexFilter_ControlsState_S);

/**
 * INDEX FILTERS SNAPSHOT
 * */
export const IndexFilter_Snapshot_S = z.string(); // capturing only index identifier is sufficient enough

export const IndexFilters_Snapshot_S = z.array(IndexFilter_Snapshot_S);
